import CollectionContainer from './CollectionContainer';

export default CollectionContainer;
